import React from 'react'
import PropTypes from 'prop-types'

// icon size should use these values -- 6, 8, 12, 16, 20, 24, 32, 36, 48, 64
const ButtonIcon = ({ label, icon, iconSize, iconPosition, filled }) => {
  return (
    <React.Fragment>
      {icon && iconPosition === 'left' && (
        <span className={`fil-button__icon-${label ? iconPosition : ''}`}>
          <fil-icon {...(filled ? { filled } : {})} icon={icon} size={iconSize} />
        </span>
      )}
      {label}
      {icon && iconPosition === 'right' && (
        <span className={`fil-button__icon-${label ? iconPosition : ''}`}>
          <fil-icon {...(filled ? { filled } : {})} icon={icon} size={iconSize} />
        </span>
      )}
    </React.Fragment>
  )
}

ButtonIcon.propTypes = {
  label: PropTypes.string,
  icon: PropTypes.string,
  iconSize: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  iconPosition: PropTypes.oneOf(['left', 'right']),
  filled: PropTypes.bool
}

ButtonIcon.defaultProps = {
  label: '',
  icon: '',
  iconSize: 12,
  iconPosition: 'right',
  filled: false
}

export default ButtonIcon
